import React from "react"
import { Link } from 'gatsby'
import { Card, Title, Author } from './styles'

function CardPost({ post }) {

  return (
    <Card>
      <Link to={`/blog/${post.node.fields.slug}`}>
        {!!post.node.frontmatter.image && (
          <img className="img" src={`${post.node.frontmatter.image}`} alt={"- Featured Shot"} />
        )}

        <Title >
          {post.node.frontmatter.title}
        </Title>
      </Link >
      <Author >Por <strong>Jonas Castro</strong> <time>{post.node.frontmatter.date}</time></Author>
    </Card >
  )
}


export default CardPost
